module.exports = __webpack_public_path__ + "img/tearsgator.a3b4d007.svg";